const ConnectWiseUsersImport = () => import('@/views/account/integrations/connectwise/import/connectwise-users-import-view.vue');
const ConnectWiseCompaniesImport = () => import('@/views/account/integrations/connectwise/import/connectwise-companies-import-view.vue');
const ConnectWiseContactsImport = () => import('@/views/account/integrations/connectwise/import/connectwise-contacts-import-view');
const ConnectWiseActivitiesImport = () => import('@/views/account/integrations/connectwise/import/connectwise-activities-import-view');
const ConnectWiseOpportunitiesImport = () => import('@/views/account/integrations/connectwise/import/connectwise-opportunities-import-view');

import store from '@/stores/index';

export default [
    {
        path: '/Integrations/ConnectWise/Manage/Users/Import',
        name: 'ConnectWiseUsersImport',
        component: ConnectWiseUsersImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/ConnectWise/Manage/Users/Import',
        name: 'ClientConnectWiseUsersImport',
        component: ConnectWiseUsersImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/ConnectWise/Manage/Companies/Import',
        name: 'ConnectWiseCompaniesImport',
        component: ConnectWiseCompaniesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/ConnectWise/Manage/Companies/Import',
        name: 'ClientConnectWiseCompaniesImport',
        component: ConnectWiseCompaniesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/ConnectWise/Manage/Contacts/Import',
        name: 'ConnectWiseContactsImport',
        component: ConnectWiseContactsImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/ConnectWise/Manage/Contacts/Import',
        name: 'ClientConnectWiseContactsImport',
        component: ConnectWiseContactsImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/ConnectWise/Manage/Activities/Import',
        name: 'ConnectWiseActivitiesImport',
        component: ConnectWiseActivitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/ConnectWise/Manage/Activities/Import',
        name: 'ClientConnectWiseActivitiesImport',
        component: ConnectWiseActivitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/ConnectWise/Manage/Opportunities/Import',
        name: 'ConnectWiseOpportunitiesImport',
        component: ConnectWiseOpportunitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/ConnectWise/Manage/Opportunities/Import',
        name: 'ClientConnectWiseOpportunitiesImport',
        component: ConnectWiseOpportunitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    }
]